import React, { useState } from 'react';
import './CRMQuestionnaire.css';
import { useNavigate } from 'react-router-dom';
import platesImage from '../assets/plates.png'; // Add this import line

function CRMQuestionnaire() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    professionalTitle: '',
    companyName: '',
    crmUsersCount: '',
    crmInUse: '',
    otherCrm: '',
    hoursSpentWeekly: '5',
    primaryUseCases: ['', '', ''],
    relevantFeatures: ['', '', ''],
    annoyingProperties: ['', '', ''],
    improvements: '',
    yearsUsingCrm: '',
    challenges: '',
    integrations: '',
    mobileCrmUsage: '',
    automationSatisfaction: '',
    dataQuality: '',
    reportingSatisfaction: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [showOtherCrm, setShowOtherCrm] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'crmInUse') {
      setShowOtherCrm(value === 'Other');
    }
    
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleArrayChange = (e, array, index) => {
    const { value } = e.target;
    const newArray = [...formData[array]];
    newArray[index] = value;
    setFormData({
      ...formData,
      [array]: newArray
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);
    
    try {
      console.log('Submitting form data:', {
        ...formData,
        professionalTitle: formData.professionalTitle.substring(0, 2) + '...',
        companyName: formData.companyName.substring(0, 2) + '...',
      });
      
      const dataToSend = {
        ...formData,
        clientTimestamp: new Date().toISOString(),
        userAgent: navigator.userAgent
      };
      
      if (showOtherCrm && formData.otherCrm) {
        dataToSend.crmInUse = formData.otherCrm;
      }
      
      console.log('Sending request to server...');
      
      const response = await fetch('https://sophie-server-1096082289128.europe-west1.run.app/api/survey', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Origin': window.location.origin
        },
        credentials: 'include',
        body: JSON.stringify(dataToSend),
      });
      
      console.log('Response status:', response.status);
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Network response was not ok' }));
        console.error('Survey submission failed:', errorData);
        throw new Error(errorData.message || 'Failed to submit survey');
      }
      
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const responseData = await response.json();
        console.log('Response data:', responseData);
        
        if (response.ok) {
          setSubmitStatus('success');
          
          setTimeout(() => {
            navigate('/questionnaire-success');
          }, 1500);
          
        } else {
          console.error('Server returned error:', responseData);
          setSubmitStatus('error');
        }
      } else {
        const textResponse = await response.text();
        console.error('Server returned non-JSON response:', textResponse);
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="modern-layout">
      <div className="gradient_background">
        {/* Add plates image as background */}
        <img src={platesImage} alt="" className="background-plates" aria-hidden="true" />
        
        <div className="content-container">
          <div className="questionnaire-container">
            <div className="form-container">
              <div className="form-header">
                <h1>CRM User Questionnaire</h1>
                <div className="subtitle">
                  <strong>Help us help you. Please take five minutes to fill our questionnaire.</strong><br />
                  <strong>Your insights helps us build better products for you.</strong>
                </div>
              </div>
              
              <form onSubmit={handleSubmit}>
                {/* Personal/Company Information */}
                <div className="form-group">
                  <label htmlFor="professionalTitle">Your professional title:</label>
                  <input
                    type="text"
                    id="professionalTitle"
                    name="professionalTitle"
                    value={formData.professionalTitle}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="companyName">Company name:</label>
                  <input
                    type="text"
                    id="companyName"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="crmUsersCount">How many people use CRM in your company?</label>
                  <select
                    id="crmUsersCount"
                    name="crmUsersCount"
                    value={formData.crmUsersCount}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Please select</option>
                    <option value="1-5">1-5</option>
                    <option value="6-20">6-20</option>
                    <option value="21-50">21-50</option>
                    <option value="51-200">51-200</option>
                    <option value="201+">201+</option>
                  </select>
                </div>
                
                {/* CRM Usage Information */}
                <div className="form-group">
                  <label htmlFor="crmInUse">Which CRM does your company use?</label>
                  <select
                    id="crmInUse"
                    name="crmInUse"
                    value={formData.crmInUse}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Please select</option>
                    <option value="Salesforce">Salesforce</option>
                    <option value="HubSpot">HubSpot</option>
                    <option value="Microsoft Dynamics">Microsoft Dynamics</option>
                    <option value="Zoho CRM">Zoho CRM</option>
                    <option value="Pipedrive">Pipedrive</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                
                {showOtherCrm && (
                  <div className="form-group">
                    <label htmlFor="otherCrm">Please specify your CRM:</label>
                    <input
                      type="text"
                      id="otherCrm"
                      name="otherCrm"
                      value={formData.otherCrm}
                      onChange={handleChange}
                      required={showOtherCrm}
                    />
                  </div>
                )}
                
                <div className="form-group">
                  <label htmlFor="yearsUsingCrm">How many years have you been using a CRM?</label>
                  <select
                    id="yearsUsingCrm"
                    name="yearsUsingCrm"
                    value={formData.yearsUsingCrm}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Please select</option>
                    <option value="Less than 1 year">Less than 1 year</option>
                    <option value="1-3 years">1-3 years</option>
                    <option value="4-7 years">4-7 years</option>
                    <option value="8+ years">8+ years</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="hoursSpentWeekly">
                    How many hours per week do you spend using your CRM? ({formData.hoursSpentWeekly} hours)
                  </label>
                  <div className="slider-container">
                    <input
                      type="range"
                      id="hoursSpentWeekly"
                      name="hoursSpentWeekly"
                      min="1"
                      max="40"
                      value={formData.hoursSpentWeekly}
                      onChange={handleChange}
                      className="slider"
                    />
                  </div>
                </div>
                
                {/* Use Cases and Features */}
                <div className="form-group">
                  <label>What are your top 3 primary use cases for your CRM?</label>
                  {formData.primaryUseCases.map((useCase, index) => (
                    <div className="numbered-input" key={index}>
                      <span>{index + 1}.</span>
                      <input
                        type="text"
                        value={useCase}
                        onChange={(e) => handleArrayChange(e, 'primaryUseCases', index)}
                        placeholder=""
                      />
                    </div>
                  ))}
                </div>
                
                <div className="form-group">
                  <label>What are the 3 most relevant features of your CRM for you?</label>
                  {formData.relevantFeatures.map((feature, index) => (
                    <div className="numbered-input" key={index}>
                      <span>{index + 1}.</span>
                      <input
                        type="text"
                        value={feature}
                        onChange={(e) => handleArrayChange(e, 'relevantFeatures', index)}
                        placeholder=""
                      />
                    </div>
                  ))}
                </div>
                
                <div className="form-group">
                  <label>What are the 3 most annoying properties of your CRM for you?</label>
                  {formData.annoyingProperties.map((property, index) => (
                    <div className="numbered-input" key={index}>
                      <span>{index + 1}.</span>
                      <input
                        type="text"
                        value={property}
                        onChange={(e) => handleArrayChange(e, 'annoyingProperties', index)}
                        placeholder=""
                      />
                    </div>
                  ))}
                </div>
                
                {/* Additional Information */}
                <div className="form-group">
                  <label htmlFor="improvements">What do you wish your CRM could do better?</label>
                  <textarea
                    id="improvements"
                    name="improvements"
                    value={formData.improvements}
                    onChange={handleChange}
                    placeholder="Please describe any improvements you'd like to see"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="challenges">What are your biggest challenges with your current CRM?</label>
                  <textarea
                    id="challenges"
                    name="challenges"
                    value={formData.challenges}
                    onChange={handleChange}
                    placeholder="Please describe your challenges"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="integrations">What other tools or platforms do you integrate with your CRM?</label>
                  <textarea
                    id="integrations"
                    name="integrations"
                    value={formData.integrations}
                    onChange={handleChange}
                    placeholder="e.g., Email marketing, Calendar, Documents, etc."
                  />
                </div>
                
                {/* Satisfaction and Usage Patterns */}
                <div className="form-group">
                  <label htmlFor="mobileCrmUsage">How often do you use CRM on your mobile device?</label>
                  <select
                    id="mobileCrmUsage"
                    name="mobileCrmUsage"
                    value={formData.mobileCrmUsage}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Please select</option>
                    <option value="Never">Never</option>
                    <option value="Rarely">Rarely</option>
                    <option value="Sometimes">Sometimes</option>
                    <option value="Often">Often</option>
                    <option value="Very frequently">Very frequently</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="automationSatisfaction">How satisfied are you with the automation capabilities of your CRM?</label>
                  <select
                    id="automationSatisfaction"
                    name="automationSatisfaction"
                    value={formData.automationSatisfaction}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Please select</option>
                    <option value="Very dissatisfied">Very dissatisfied</option>
                    <option value="Dissatisfied">Dissatisfied</option>
                    <option value="Neutral">Neutral</option>
                    <option value="Satisfied">Satisfied</option>
                    <option value="Very satisfied">Very satisfied</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="dataQuality">How would you rate the data quality in your CRM?</label>
                  <select
                    id="dataQuality"
                    name="dataQuality"
                    value={formData.dataQuality}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Please select</option>
                    <option value="Very poor">Very poor</option>
                    <option value="Poor">Poor</option>
                    <option value="Average">Average</option>
                    <option value="Good">Good</option>
                    <option value="Excellent">Excellent</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="reportingSatisfaction">How satisfied are you with the reporting capabilities of your CRM?</label>
                  <select
                    id="reportingSatisfaction"
                    name="reportingSatisfaction"
                    value={formData.reportingSatisfaction}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Please select</option>
                    <option value="Very dissatisfied">Very dissatisfied</option>
                    <option value="Dissatisfied">Dissatisfied</option>
                    <option value="Neutral">Neutral</option>
                    <option value="Satisfied">Satisfied</option>
                    <option value="Very satisfied">Very satisfied</option>
                  </select>
                </div>
                
                {/* Add the disclaimer section before the submit button */}
                <div className="disclaimer">
                  <h3>Disclaimer:</h3>
                  <p>By participating in this questionnaire, you acknowledge and agree to the following terms:</p>
                  
                  <ol>
                    <li><strong>Anonymity:</strong> This questionnaire is completely anonymous. No personal contact details or identifiable information will be collected or stored.</li>
                    <li><strong>Purpose of Data Collection:</strong> All information gathered through this questionnaire will be used solely by Sophie Datagen for the purpose of product development and improvement. Your responses will help us understand your needs and preferences better, enabling us to enhance our products and services.</li>
                    <li><strong>Confidentiality:</strong> Your responses will be kept confidential and will not be shared with any third parties. The data will be aggregated and analyzed in a manner that ensures your anonymity is maintained.</li>
                    <li><strong>No Commercial Use:</strong> The information provided will not be used for any commercial purposes or sold to any third parties. It will strictly be used for internal research and development at Sophie Datagen.</li>
                    <li><strong>Voluntary Participation:</strong> Your participation in this questionnaire is voluntary. You may choose not to participate or to withdraw your consent at any time without any consequences.</li>
                    <li><strong>Data Storage:</strong> The data collected will be stored securely and will be accessible only to authorized personnel at Sophie Datagen. We will take all necessary measures to protect your data from unauthorized access, disclosure, or misuse.</li>
                    <li><strong>Compliance with Laws:</strong> We comply with all applicable data protection laws and regulations to ensure the privacy and security of your information.</li>
                  </ol>
                  
                  <p>By completing and submitting this questionnaire, you consent to the collection and use of your responses as described above. If you have any questions or concerns regarding this disclaimer or the questionnaire, please contact us at <a href="mailto:hello@sophiedoc.ai">hello@sophiedoc.ai</a></p>
                </div>
                
                <button type="submit" disabled={isSubmitting} className="submit-button">
                  {isSubmitting ? 'Submitting...' : 'Submit Questionnaire'}
                </button>
                
                {submitStatus === 'success' && (
                  <div className="success-message">
                    Thank you for completing the questionnaire! Your responses have been submitted.
                  </div>
                )}
                
                {submitStatus === 'error' && (
                  <div className="error-message">
                    There was an error submitting your response. Please try again later.
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default CRMQuestionnaire;